import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class MilliAmpsAttribute extends Sensor {
  public milliAmpsChart: any;
  private milliAmpsSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.milliAmpsChart = null;
    this.milliAmpsSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.milliAmpsSensor, position);
      this.milliAmpsSensor[position].push([timestamp, element.milliAmps]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredMilliAmps = this.milliAmpsSensor.filter(series => series.length > 0);

    const positionNodeMilliAmps = this.milliAmpsSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.milliAmpsChart = this.getConfigChar(
      'milliAmps',
      this.getChartSeriesNewNode('Sensor', filteredMilliAmps, positionNodeMilliAmps),
      this.getRanges('milliAmps'),
      this.getLimits('milliAmps')
    );
  }

  public hasMilliAmpsSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.milliAmpsSensor.length &&
      this.milliAmpsSensor[index].length > 0
    );
  }

  public getMilliAmpsSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.milliAmpsSensor.length) {
      const sensorData = this.milliAmpsSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Miliamperios', value: 'milliAmps' }
    ];
  }
}
